import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'

import './SegmentationComponent.scss'

export default class SegmentationComponent extends React.Component {
  static propTypes = {
    topicPlanSegments: PropTypes.array.isRequired,
    onClick: PropTypes.func,
    selected: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.styles = {
      beta: {
        color: '#A9A9A9',
        display: 'inline'
      },
      divider: {
        borderBottom: '1px solid rgb(107, 105, 105)',
        width: '100%'
      },
      heading: {
      fontWeight: 'bold',
      fontSize: '14px'
      },
      themeHeading: {
        fontWeight: 'bold',
        fontSize: '14px',
        display: 'flex',
        marginTop: '15px'
      },
      theme: {
        fontWeight: 'normal'
      }
    }
  }

  renderSegmentationBar () {
    return this.props.topicPlanSegments.map((item, index) => {
      let percentage = Number(item.percentage).toFixed(0)
      const max = Math.max(percentage, 1.0)
      const widthPercent = 1.25 * max
      const alpha = max / 10
      const color = `0,156,137,${alpha}`
      const segmentBarWidth = {
        width: `${widthPercent}%`,
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: `${widthPercent}%`
      }
      const segmentBarColor = {
        backgroundColor: `rgba(${color})`
      }
      const textClassName = alpha > 0.5 ? 'color-white segment-text' : 'color-green segment-text'
      const selectedClassName = this.props.selected.indexOf(item.segment) > -1 ? 'shade selected' : 'shade'
      const click = () => this.props.onClick(item.segment)
      return (
        <div key={index} className='fl-center cursorPointer' style={segmentBarWidth}>
          <div className={selectedClassName} style={segmentBarColor} onClick={click}>
            <h5 className={textClassName}>{percentage}%</h5>
          </div>
        </div>
      )
    })
  }

  renderSegmentationTheme () {
    if (this.props.selected.length) {
      let themes = []
      this.props.topicPlanSegments.forEach(item => {
        if (this.props.selected.includes(item.segment)) {
          themes = themes.concat(item.attributes || [])
        }
      })
      if (themes.length) {
        return themes.map(theme => {
          return (
            <li key={theme}>{theme}</li>
          )
        })
      } else {
        return (<li key='none'><i>no themes available</i></li>)
      }
    } else {
      return (
        <li>click bar chart above to view segment themes</li>
      )
    }
  }

  render () {
    return (
      <>
        <>
          <span className="demoHeader segmentHeader">
            Segmentation
          </span>
          <Col lg={12} className="mt-15">
            <div className="range-bar">
              {this.renderSegmentationBar()}
            </div>
          </Col>
        </>
        <Row>
          <div style={this.styles.themeHeading}>
            <div>
              Segment Theme
              <span style={this.styles.beta}>&nbsp;(beta):</span>
            </div>
            <ul className="segTheme" style={this.styles.theme}>
              {this.renderSegmentationTheme()}
            </ul>
          </div>
        </Row>
      </>
    )
  }
}
